import React from 'react';
import { Box } from '@mui/material';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import useMessageStyles from '../../../hooks/useMessageStyles';
import { useMessageBubbleContext } from './MessageBubbleContext';
import MessageMediaMetaOverlay from './MessageMediaMetaOverlay';

export default function MessageMediaFrame({
  kind = 'image',
  url,
  alt = 'Shared media',
  bleed = false,
  compact = true,
  onError,
}) {
  const {
    messageMediaFrameSx,
    messageMediaFrameBleedSx,
    messageMediaFrameBleedCompactSx,
    messageMediaImageSx,
    messageMediaVideoSx,
    messageMediaOverlaySx,
  } = useMessageStyles();
  const { metaOverlay } = useMessageBubbleContext();

  if (!url) return null;

  const frameSx = {
    ...messageMediaFrameSx,
    ...(bleed ? (compact ? messageMediaFrameBleedCompactSx : messageMediaFrameBleedSx) : null),
  };

  const showMetaOverlay = metaOverlay?.show && compact;

  if (kind === 'video') {
    return (
      <Box sx={frameSx}>
        <Box component="video" controls src={url} sx={messageMediaVideoSx} />
        {showMetaOverlay && <MessageMediaMetaOverlay />}
      </Box>
    );
  }

  if (kind === 'audio') {
    return (
      <Box sx={{ ...frameSx, px: 0.75, py: 0.5, maxWidth: { xs: 240, sm: 280 } }}>
        <Box component="audio" controls src={url} sx={{ width: '100%', minWidth: 180 }} />
      </Box>
    );
  }

  return (
    <Box
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ ...frameSx, display: 'block', position: 'relative', textDecoration: 'none' }}
    >
      <Box
        component="img"
        src={url}
        alt={alt}
        loading="lazy"
        sx={messageMediaImageSx}
        onError={onError}
      />
      {kind === 'video-preview' && (
        <Box sx={messageMediaOverlaySx}>
          <PlayCircleOutlineRoundedIcon sx={{ fontSize: 40, color: '#fff' }} />
        </Box>
      )}
      {showMetaOverlay && <MessageMediaMetaOverlay />}
    </Box>
  );
}
